/* eslint-disable */
import React, {
  useState,
  createContext,
  useContext,
  useEffect,
  useCallback,
  useRef,
} from "react";
import PropTypes from "prop-types";

import { useScoreboardContext } from "../../../contexts/ScoreboardContext";
import { db } from "../../../firebase";
import useTranslations from "../../../contexts/useTranslations";
import { onValue, ref, set, update } from "firebase/database";
import { setCurrentScreen } from "firebase/analytics";

const TennisContext = createContext();

export function useTennisContext() {
  return useContext(TennisContext);
}

export const TennisProvider = ({ children }) => {
  const t = useTranslations();
  const gameOverHandled = useRef(false);

  const {
    currentSport,
    setCurrentSport,
    currentScoreboard,
    setCurrentScoreboard,
    teamA,
    setTeamA,
    teamB,
    setTeamB,
    generatedCode,
    colors,
    enableFB,
    setEnableFB,
    tennisVariant,
    setTennisVariant,
    crest,
    setCrest,
  } = useScoreboardContext();

  // 0 = tennis, 1 = ping pong, 2 = pickle ball
  const [sets, setSets] = useState([0, 0]);
  const [legs, setLegs] = useState([0, 0]);
  const [gameModeLegs, setGameModeLegs] = useState("t");
  const [tiebreakLegs, setTiebreakLegs] = useState(6);
  const [firstToGames, setFirstToGames] = useState(7);
  const [firstToPoints, setFirstToPoints] = useState(11);
  const [gameNumber, setGameNumber] = useState(0); // live game number
  const [totalNumberOfGames, setTotalNumberOfGames] = useState(3);

  const [finalLegIsTiebreaker, setFinalLegIsTiebreaker] = useState(true);
  const [scoreIsTiebreaker, setScoreIsTiebreaker] = useState(false);
  const [isFirstServer, setIsFirstServer] = useState(true);
  const [isInitialGameServe, setIsInitialGameServe] = useState(true);
  const [isGoldenPoint, setIsGoldenPoint] = useState(true);
  const [currentScore, setCurrentScore] = useState([0, 0]);
  const [notice, setNotice] = useState(t("noun:notice-text"));
  const [showNotice, setShowNotice] = useState(false);
  const [showModalSettings, setShowSettingsModal] = useState(false);
  const [showModalFeedback, setShowModalFeedback] = useState(false);
  const [isManualScores, setIsManualScores] = useState(false);
  const [gameIsOver, setGameIsOver] = useState(false);

  const [undoHistory, setUndoHistory] = useState([
    {
      currentScore: currentScore,
      legs: [0, 0],
      sets: [0, 0],
      isFirstServer: isFirstServer,
      finalLegIsTiebreaker,
      scoreIsTiebreaker,
      gameNumber,
      gameIsOver,
    },
  ]);

  let value;

  const addScore = (player) => {
    if (tennisVariant === "0") {
      if (scoreIsTiebreaker) addPointsTiebreaker(player);
      else addPointsRegular(player);
    } else if (tennisVariant === "1") {
      addPointsPingPong(player);
    } else if (tennisVariant === "3") {
      addPointsPadel(player + 1);
    } else {
      console.log("pickle");
      addPointsPickle(player + 1);
    }
  };

  const addPointsRegular = (player) => {
    let otherPlayer = player === 0 ? 1 : 0;
    let points = 0;
    let _isFirstServer = isFirstServer;

    addHistory();

    if (
      (currentScore[player] === 40 && currentScore[otherPlayer] !== 40) ||
      currentScore[player] === "AD"
    ) {
      if (gameModeLegs === "t") {
        getTiebreakLegs(player);
      } else if (gameModeLegs === "a") {
        getAdvantage(player);
      }

      setCurrentScore([0, 0]);
      setShowNotice(false);

      // _isFirstServer = !_isFirstServer;

      updateFB({
        showNotice: false,
        notice,
        currentScore: [0, 0],
        isFirstServer: _isFirstServer,
      });
      // setIsFirstServer(_isFirstServer);
    } else if (currentScore[player] === 0) {
      points = 15;
    } else if (currentScore[player] === 15) {
      points = 30;
    } else {
      points = 40;
      if (
        (isFirstServer ? 1 : 0) === player &&
        currentScore[otherPlayer] < 40
      ) {
        setNotice(t("noun:breakpoint"));
        setShowNotice(true);
        updateFB({
          showNotice: true,
          notice: t("noun:breakpoint"),
        });
      }
    }

    if (points === 40 && currentScore[otherPlayer] === 40) {
      setShowNotice(false);
    }

    if (currentScore[player] === 40 && currentScore[otherPlayer] === 40) {
      points = "AD";
      lastPoints(player, otherPlayer, "AD", "");
    } else if (currentScore[otherPlayer] === "AD") {
      points = "LV";
      lastPoints(player, otherPlayer, 40, 40);
    } else
      setCurrentScore((score) => {
        let _score = [...score];
        _score[player] = points;
        updateFB({ currentScore: _score });
        return _score;
      });

    if ((isFirstServer ? 1 : 0) === player && points === "AD") {
      let note = t("noun:breakpoint");
      setNotice(note);
      setShowNotice(true);
      updateFB({ notice: note, showNotice: true });
    }

    if (points === "LV" && showNotice) {
      setShowNotice(false);
      updateFB({ showNotice: false, notice });
    }
  };

  const addPointsTiebreaker = (player) => {
    let otherPlayer = player === 0 ? 1 : 0;
    let cs1 = currentScore[player] + 1;
    let cs2 = currentScore[otherPlayer];
    let _currentScore = [...currentScore];
    let _sets = [...sets];
    let _isFirstServer = isFirstServer;
    let _scoreIsTiebreaker = scoreIsTiebreaker;

    addHistory();

    if (cs1 >= firstToGames && cs1 - cs2 >= 2) {
      _currentScore = [0, 0];
      _sets[player]++;
      setSets(_sets);
      setLegs([0, 0]);
      setScoreIsTiebreaker(false);
      _isFirstServer = !_isFirstServer;
      _scoreIsTiebreaker = false;
      setIsFirstServer(_isFirstServer);
    } else {
      _currentScore[player]++;

      if ((_currentScore[0] + _currentScore[1]) % 2 != 0) {
        _isFirstServer = !_isFirstServer;
        setIsFirstServer(_isFirstServer);
      }
    }
    updateFB({
      sets: [..._sets],
      legs: [...legs],
      scoreIsTiebreaker: _scoreIsTiebreaker,
      isFirstServer: _isFirstServer,
      currentScore: _currentScore,
    });
    // updateFB({ currentScore: _currentScore, isFirstServer: _isFirstServer });
    setCurrentScore(_currentScore);
  };

  const getTiebreakLegs = (player) => {
    let otherPlayer = player === 0 ? 1 : 0;
    let _sets = [...sets];
    let _legs = [...legs];
    let l1 = _legs[player] + 1;
    let l2 = _legs[otherPlayer];
    let _tiebreakLegs = parseInt(tiebreakLegs);
    let _scoreIsTiebreaker = scoreIsTiebreaker;
    let _isInitialGameServe = isInitialGameServe;
    let _isFirstServer = isFirstServer;
    console.log({ l1, l2, _tiebreakLegs });

    if (finalLegIsTiebreaker && l1 === _tiebreakLegs && l2 === _tiebreakLegs) {
      console.log("tiebreak");
      _scoreIsTiebreaker = true;
      setScoreIsTiebreaker(_scoreIsTiebreaker);
      setCurrentScore([0, 0]);
      _legs[player]++;
      setLegs(_legs);
      setIsInitialGameServe(player !== 0);
    } else {
      console.log("not tiebreak");
      if (l1 >= _tiebreakLegs && l1 - l2 >= 2) {
        _sets[player]++;
        _legs = [0, 0];
        _isFirstServer = !_isInitialGameServe;
        _isInitialGameServe = !_isInitialGameServe;
        setIsFirstServer(_isFirstServer);
        setIsInitialGameServe(!_isInitialGameServe);
      } else {
        _legs[player]++;
        setIsFirstServer(!isFirstServer);
      }

      setSets(_sets);
      setLegs(_legs);
    }

    updateFB({
      sets: _sets,
      legs: _legs,
      scoreIsTiebreaker: _scoreIsTiebreaker,
      isInitialGameServe: _isInitialGameServe,
    });
  };

  const getAdvantage = (currentPlayer) => {
    let otherPlayer = currentPlayer === 0 ? 1 : 0;
    let l1 = legs[currentPlayer] + 1;
    let l2 = legs[otherPlayer];
    let _isFirstServer = isFirstServer;
    let _isInitialGameServe = isInitialGameServe;

    if (l1 >= firstToGames && l1 - l2 > 1) {
      setLegs([0, 0]);
      setSets((_sets) => {
        let temp = [..._sets];
        temp[currentPlayer]++;
        updateFB({
          sets: temp,
          legs: [0, 0],
          isFirstServer: _isInitialGameServe,
          isInitialGameServe: !_isInitialGameServe,
        });
        return temp;
      });
      setIsFirstServer(_isInitialGameServe);
      setIsInitialGameServe(!_isInitialGameServe);
    } else {
      setLegs((_legs) => {
        let temp = [..._legs];
        temp[currentPlayer]++;
        updateFB({ legs: temp });
        return temp;
      });
      setIsFirstServer(!isFirstServer);
    }
  };

  const addPointsPickle = (player) => {
    let _currentScore = [...currentScore];
    let _legs = [...legs];
    let _gameIsOver = gameIsOver;
    let otherPlayer = player === 1 ? 2 : 1;

    if (!gameIsOver) addHistory();

    let _p1Score = _currentScore[gameNumber]["player" + player];
    let _p2Score = _currentScore[gameNumber]["player" + otherPlayer];

    if (_p1Score + 1 >= firstToPoints && _p1Score + 1 - _p2Score > 1) {
      if (gameIsOver === false) {
        _currentScore[gameNumber]["player" + player]++;

        if (
          _legs[player - 1] + 1 + 1 <
          totalNumberOfGames - _legs[player - 1]
        ) {
          _legs[player - 1]++;
          setLegs(_legs);
          _currentScore = [...currentScore];
          if (!_gameIsOver) _currentScore.push({ player1: 0, player2: 0 });
          updateFB({
            currentScore: _currentScore,
            legs: _legs,
          });
          setGameNumber((_num) => {
            let _temp = _num + 1;
            updateFB({ gameNumber: _temp });
            return _temp;
          });
        } else {
          updateFB({
            notice: "Match Over",
            gameIsOver: true,
            showNotice: true,
          });
          setNotice("Match Over");
          setShowNotice(true);
          setGameIsOver(true);
        }
      }
    } else {
      _currentScore[gameNumber]["player" + player]++;
    }

    updateFB({
      currentScore: [..._currentScore],
    });

    if (!gameIsOver) setCurrentScore([..._currentScore]);
  };

  const WIN_MARGIN = 2;
  // Function to add a score for a player
  const addPointsPingPong = (player) => {
    if (gameIsOver) return;
    setCurrentScore((prevScore) => {
      const newScore = [...prevScore];
      newScore[player]++;
      let _isFirstServer = isFirstServer;
      let otherPlayer = player === 0 ? 1 : 0;

      // Determine server change based on score
      if (
        newScore[player] >= firstToPoints - 1 &&
        newScore[otherPlayer] >= firstToPoints - 1
      ) {
        _isFirstServer = !_isFirstServer;
        setIsFirstServer(_isFirstServer);
      } else if ((newScore[0] + newScore[1]) % 2 === 0) {
        _isFirstServer = !_isFirstServer;
        setIsFirstServer(_isFirstServer);
      }

      // Check if the game is over with the updated score
      if (isGameOver(newScore)) {
        let _isInitialGameServe = !isInitialGameServe;
        _isFirstServer = _isInitialGameServe;
        setIsFirstServer(_isInitialGameServe);
        setIsInitialGameServe(_isInitialGameServe);
        handleGameWin(player, newScore);

        // Update Firebase with game over state and final score
        updateFB({
          currentScore: newScore,
          isFirstServer: _isFirstServer,
          isInitialGameServe: _isInitialGameServe,
        });
      } else {
        // Update Firebase with current score during ongoing game
        updateFB({
          currentScore: newScore,
          isFirstServer: _isFirstServer,
        });
      }

      return newScore;
    });

    // Update Firebase with game history if game is not over
    if (!gameIsOver) addHistory();
  };

  const hasPlayerWonMatch = (legs, bestOf) => {
    // Calculate the minimum games required to win the match
    const gamesToWin = Math.ceil(bestOf / 2);

    // Check if either player has reached the gamesToWin threshold
    return legs[0] >= gamesToWin || legs[1] >= gamesToWin;
  };

  // Check if the game is over based on the current score
  const isGameOver = (score) => {
    return (
      (score[0] >= firstToPoints && score[0] - score[1] >= WIN_MARGIN) ||
      (score[1] >= firstToPoints && score[1] - score[0] >= WIN_MARGIN)
    );
  };

  // Handle the end of a game, updating the legs and resetting the score
  const handleGameWin = (winner, score) => {
    setLegs((prevLegs) => {
      const newLegs = [...prevLegs];
      newLegs[winner]++;
      let notice = "";
      let showNotice = false;
      let gameIsOver = false;

      if (hasPlayerWonMatch(newLegs, totalNumberOfGames)) {
        notice = "Match Over";
        showNotice = true;
        gameIsOver = true;
        setNotice("Match Over");
        setShowNotice(true);
        setGameIsOver(true);
      }
      updateFB({ legs: newLegs, gameIsOver, showNotice, notice });
      return newLegs;
    });
    resetCurrentScore();
  };

  // Reset the current game score
  const resetCurrentScore = () => {
    setCurrentScore([0, 0]);
  };

  // Reset the entire match
  const resetMatch = () => {
    setCurrentScore([0, 0]);
    setLegs([0, 0]);
  };

  const resetScoreboard = () => {
    let _currentScore = [0, 0];
    let _isInitialGameServe = isInitialGameServe;
    if (["0", "1"].includes(tennisVariant)) {
      setCurrentScore(_currentScore);
      setSets([0, 0]);
    } else if (tennisVariant === "3") {
      // Padel: reset all relevant state to original settings
      let _isInitialGameServe = true;
      _currentScore = [
        { player1: 0, player2: 0 },
        { player1: 0, player2: 0 },
      ];
      setCurrentScore(_currentScore);
      setGameNumber(0);
      setGameIsOver(false);
      setSets([0, 0]);
      setLegs([0, 0]);
      setIsFirstServer(true);
      setShowNotice(false);
      setUndoHistory([
        {
          currentScore: _currentScore,
          legs: [0, 0],
          sets: [0, 0],
          isFirstServer: true,
          isInitialGameServe: true,
          finalLegIsTiebreaker: true,
          scoreIsTiebreaker: false,
          gameNumber: 0,
          gameIsOver: false,
          showNotice: false,
          finalLegIsTiebreaker: true,
          isInitialGameServe: _isInitialGameServe,
          notice: "",
          isGoldenPoint: isGoldenPoint,
          gameModeLegs: gameModeLegs,
          tiebreakLegs: tiebreakLegs,
          firstToGames: firstToGames,
          firstToPoints: firstToPoints,
          totalNumberOfGames: totalNumberOfGames,
        },
      ]);
    } else {
      _currentScore = [{ player1: 0, player2: 0 }];
      setCurrentScore(_currentScore);
      setGameNumber(0);
      setGameIsOver(false);
    }

    setGameIsOver(false);
    setIsFirstServer(true);
    setLegs([0, 0]);
    setShowNotice(false);

    updateFB({
      currentScore: _currentScore,
      sets: [0, 0],
      legs: [0, 0],
      gameNumber: 0,
      gameIsOver: false,
      isFirstServer: true,
      showNotice: false,
      isInitialGameServe: _isInitialGameServe,
    });
  };

  const initiateDB = (code) => {
    setEnableFB(true);
    set(
      ref(db, "monitors/" + code), // Reference to the location to set
      {
        started: false,
        sets: [...sets],
        legs: [...legs],
        currentScore: [...currentScore],
        firstToPoints,
        gameNumber,
        totalNumberOfGames,
        gameIsOver,
        firstToGames,
        tennisVariant,
        teamA,
        isGoldenPoint,
        teamB,
        currentSport,
        currentScoreboard,
        gameModeLegs,
        tiebreakLegs,
        firstToGames,
        finalLegIsTiebreaker,
        scoreIsTiebreaker,
        isFirstServer,
        notice,
        showNotice,
        isManualScores,
        colors,
        currentScoreboard,
        crest,
      }
    );
  };

  // const getFirstTo = (currentPlayer) => {
  //   if (legs[currentPlayer] + 1 >= firstToLegs && hasSets) {
  //     setLegs([0, 0]);
  //     setSets((_sets) => {
  //       let tempSets = [..._sets];
  //       tempSets[currentPlayer]++;
  //       return tempSets;
  //     });
  //   } else {
  //     setLegs((leg) => {
  //       let tempScore = [...leg];
  //       tempScore[currentPlayer]++;
  //       return tempScore;
  //     });
  //     setCurrentScore([0, 0]);
  //   }
  // };

  // const getBestOf = (currentPlayer) => {
  //   let otherPlayer = currentPlayer === 0 ? 1 : 0;
  //   let l1 = legs[currentPlayer] + 1;
  //   let l2 = legs[otherPlayer];

  //   if (l1 > firstToLegs - l1 && hasSets) {
  //     setLegs([0, 0]);
  //     setSets((_sets) => {
  //       let temp = [..._sets];
  //       temp[currentPlayer]++;
  //       return temp;
  //     });
  //   } else if (l2 > firstToLegs - l2 && hasSets) {
  //     setLegs([0, 0]);
  //     setSets((_sets) => {
  //       let temp = [..._sets];
  //       temp[currentPlayer]++;
  //       return temp;
  //     });
  //   } else {
  //     setLegs((_legs) => {
  //       let tempScore = [..._legs];
  //       tempScore[currentPlayer]++;
  //       return tempScore;
  //     });
  //   }
  // };

  const addHistory = useCallback(() => {
    // Create deep copy of currentScore to prevent reference issues
    const newArray =
      tennisVariant === "2"
        ? currentScore.map((obj) => ({ ...obj }))
        : [...currentScore];

    // Create deep copies of all state that needs to be tracked
    const historyState = {
      // Score related
      currentScore: newArray,
      legs: [...legs],
      sets: [...sets],
      gameNumber: gameNumber,

      // Game state
      isFirstServer: isFirstServer,
      isInitialGameServe: isInitialGameServe,
      scoreIsTiebreaker: scoreIsTiebreaker,
      finalLegIsTiebreaker: finalLegIsTiebreaker,
      gameIsOver: gameIsOver,

      // Notifications
      showNotice: showNotice,
      notice: notice,

      // Game settings
      isManualScores: isManualScores,
      isGoldenPoint: isGoldenPoint,

      // Game type specific
      gameModeLegs: gameModeLegs,
      tiebreakLegs: tiebreakLegs,
      firstToGames: firstToGames,
      firstToPoints: firstToPoints,
      totalNumberOfGames: totalNumberOfGames,
    };

    setUndoHistory((hist) => [...hist, historyState]);
  }, [
    currentScore,
    legs,
    sets,
    gameNumber,
    isFirstServer,
    isInitialGameServe,
    scoreIsTiebreaker,
    finalLegIsTiebreaker,
    gameIsOver,
    showNotice,
    notice,
    isManualScores,
    isGoldenPoint,
    gameModeLegs,
    tiebreakLegs,
    firstToGames,
    firstToPoints,
    totalNumberOfGames,
    tennisVariant,
  ]);

  const undo = () => {
    const undoHistoryLength = undoHistory.length;

    if (undoHistoryLength > 1) {
      const lastHistory = undoHistory[undoHistoryLength - 1];

      // Update all state variables from history
      setCurrentScore([...lastHistory.currentScore]);
      setLegs([...lastHistory.legs]);
      setSets([...lastHistory.sets]);
      setGameNumber(lastHistory.gameNumber);
      setIsFirstServer(lastHistory.isFirstServer);
      setIsInitialGameServe(lastHistory.isInitialGameServe);
      setScoreIsTiebreaker(lastHistory.scoreIsTiebreaker);
      setFinalLegIsTiebreaker(lastHistory.finalLegIsTiebreaker);
      setGameIsOver(lastHistory.gameIsOver);
      setShowNotice(lastHistory.showNotice);
      setNotice(lastHistory.notice);
      setIsManualScores(lastHistory.isManualScores);
      setIsGoldenPoint(lastHistory.isGoldenPoint);
      setGameModeLegs(lastHistory.gameModeLegs);
      setTiebreakLegs(lastHistory.tiebreakLegs);
      setFirstToGames(lastHistory.firstToGames);
      setFirstToPoints(lastHistory.firstToPoints);
      setTotalNumberOfGames(lastHistory.totalNumberOfGames);

      // Reset game over handled flag
      gameOverHandled.current = false;

      // Update Firebase with all state changes
      updateFB({
        currentScore: [...lastHistory.currentScore],
        sets: [...lastHistory.sets],
        legs: [...lastHistory.legs],
        gameNumber: lastHistory.gameNumber,
        isFirstServer: lastHistory.isFirstServer,
        isInitialGameServe: lastHistory.isInitialGameServe,
        scoreIsTiebreaker: lastHistory.scoreIsTiebreaker,
        finalLegIsTiebreaker: lastHistory.finalLegIsTiebreaker,
        gameIsOver: lastHistory.gameIsOver,
        showNotice: lastHistory.showNotice,
        notice: lastHistory.notice,
        isManualScores: lastHistory.isManualScores,
        isGoldenPoint: lastHistory.isGoldenPoint,
        gameModeLegs: lastHistory.gameModeLegs,
        tiebreakLegs: lastHistory.tiebreakLegs,
        firstToGames: lastHistory.firstToGames,
        firstToPoints: lastHistory.firstToPoints,
        totalNumberOfGames: lastHistory.totalNumberOfGames,
      });

      // Remove the last history entry
      setUndoHistory((hist) => {
        const newHist = [...hist];
        newHist.pop();
        return newHist;
      });
    } else {
      // Reset to initial state if no history
      const initialState = {
        currentScore:
          tennisVariant === "3"
            ? [
                { player1: 0, player2: 0 },
                { player1: 0, player2: 0 },
              ]
            : tennisVariant === "2"
            ? [{ player1: 0, player2: 0 }]
            : [0, 0],
        sets: [0, 0],
        legs: [0, 0],
        gameNumber: 0,
        isFirstServer: true,
        isInitialGameServe: true,
        scoreIsTiebreaker: false,
        finalLegIsTiebreaker: true,
        gameIsOver: false,
        showNotice: false,
        notice: "",
        isManualScores: false,
        isGoldenPoint: true,
        gameModeLegs: "t",
        tiebreakLegs: 6,
        firstToGames: 7,
        firstToPoints: 11,
        totalNumberOfGames: 3,
      };

      // Reset all state to initial values
      setCurrentScore(initialState.currentScore);
      setSets(initialState.sets);
      setLegs(initialState.legs);
      setGameNumber(initialState.gameNumber);
      setIsFirstServer(initialState.isFirstServer);
      setIsInitialGameServe(initialState.isInitialGameServe);
      setScoreIsTiebreaker(initialState.scoreIsTiebreaker);
      setFinalLegIsTiebreaker(initialState.finalLegIsTiebreaker);
      setGameIsOver(initialState.gameIsOver);
      setShowNotice(initialState.showNotice);
      setNotice(initialState.notice);
      setIsManualScores(initialState.isManualScores);
      setIsGoldenPoint(initialState.isGoldenPoint);
      setGameModeLegs(initialState.gameModeLegs);
      setTiebreakLegs(initialState.tiebreakLegs);
      setFirstToGames(initialState.firstToGames);
      setFirstToPoints(initialState.firstToPoints);
      setTotalNumberOfGames(initialState.totalNumberOfGames);

      // Update Firebase with initial state
      updateFB(initialState);
    }
  };

  const lastPoints = (player, otherPlayer, point1, point2) => {
    setCurrentScore((score) => {
      let _score = [...score];
      _score[otherPlayer] = point2;
      _score[player] = point1;
      updateFB({ currentScore: _score });
      return _score;
    });
  };

  // padel
  function addPointsPadel(winner) {
    if (gameIsOver) return;

    addHistory();

    const currentPlayerKey = "player" + winner;
    const otherPlayerKey = winner === 1 ? "player2" : "player1";
    const currentSetIndex = currentScore.length - 2;
    const currentGameIndex = currentScore.length - 1;

    setCurrentScore((prev) => {
      const temp = prev.map((item) => ({ ...item }));
      const currentGame = temp[currentGameIndex];
      const currentSet = temp[currentSetIndex];

      // Handle tiebreak game
      if (currentGame.type === "tiebreak") {
        return handleTiebreakGame(
          temp,
          currentGame,
          currentSet,
          winner,
          currentPlayerKey
        );
      }

      // Handle regular game
      return handleRegularGame(
        temp,
        currentGame,
        currentSet,
        winner,
        currentPlayerKey,
        otherPlayerKey
      );
    });
  }

  function handleTiebreakGame(
    temp,
    currentGame,
    currentSet,
    winner,
    currentPlayerKey
  ) {
    let _isFirstServer = isFirstServer;
    const otherPlayerKey =
      currentPlayerKey === "player1" ? "player2" : "player1";

    // Initialize score if not a number
    if (typeof currentGame[currentPlayerKey] !== "number") {
      currentGame[currentPlayerKey] = 0;
    }

    currentGame[currentPlayerKey] += 1;
    const p1TB = currentGame.player1;
    const p2TB = currentGame.player2;

    // Check if tiebreak is won (7 points with 2-point advantage)
    if ((p1TB >= 7 || p2TB >= 7) && Math.abs(p1TB - p2TB) >= 2) {
      // Update set score
      if (p1TB > p2TB) {
        currentSet.player1 += 1;
      } else {
        currentSet.player2 += 1;
      }
      // Check if match is won after tiebreak set
      const newSets = [...sets];
      if (p1TB > p2TB) newSets[0]++;
      else newSets[1]++;
      if (hasPlayerWonMatch(newSets, totalNumberOfGames)) {
        setNotice("Match Over");
        setShowNotice(true);
        setGameIsOver(true);
        gameOverHandled.current = true;
        // Remove the last object in currentScore when game is over
        temp.pop();
        setSets(newSets);
        updateFB({
          sets: newSets,
          currentScore: temp,
          gameIsOver: true,
          showNotice: true,
          notice: "Match Over",
        });
        return temp;
      }
      // If match not over, create a new set after a tiebreak win
      temp[temp.length - 1] = { player1: 0, player2: 0, type: "regular" };
      _isFirstServer = (currentSet.player1 + currentSet.player2) % 2 === 0;
      setIsFirstServer(_isFirstServer);
      temp.splice(temp.length, 0, { player1: 0, player2: 0 });
      setSets(newSets);
      updateFB({
        currentScore: temp,
        sets: newSets,
        isFirstServer: _isFirstServer,
      });
      return temp;
    }
    updateFB({ currentScore: temp, isFirstServer: _isFirstServer });
    return temp;
  }

  function handleRegularGame(
    temp,
    currentGame,
    currentSet,
    winner,
    currentPlayerKey,
    otherPlayerKey
  ) {
    const _isFirstServer = isFirstServer;
    const p1Points = currentGame.player1;
    const p2Points = currentGame.player2;
    let _notice = notice;
    let _showNotice = showNotice;

    // Handle advantage scenarios
    if (p1Points === "AD" || p2Points === "AD") {
      if (
        (p1Points === "AD" && currentPlayerKey === "player1") ||
        (p2Points === "AD" && currentPlayerKey === "player2")
      ) {
        // Win game on advantage
        currentSet[currentPlayerKey] += 1;
        temp[temp.length - 1] = { player1: 0, player2: 0, type: "regular" };
        let _isFirstServer =
          (currentSet.player1 + currentSet.player2) % 2 === 0;
        setIsFirstServer(_isFirstServer);
        _showNotice = false;
      } else {
        // Return to deuce
        currentGame.player1 = 40;
        currentGame.player2 = 40;
      }
      updateFB({ currentScore: temp, isFirstServer: _isFirstServer });
      setShowNotice(_showNotice);
      setNotice(_notice);
      return temp;
    }

    // Handle deuce (40-40)
    if (p1Points === 40 && p2Points === 40) {
      if (isGoldenPoint) {
        // Win game on golden point
        currentSet[currentPlayerKey] += 1;
        temp[temp.length - 1] = { player1: 0, player2: 0, type: "regular" };
        _isFirstServer = (currentSet.player1 + currentSet.player2) % 2 === 0;
        setIsFirstServer(_isFirstServer);
      } else {
        // Go to advantage
        currentGame[currentPlayerKey] = "AD";
        currentGame[otherPlayerKey] = 40;

        // Show break point if receiving team has advantage
        if (
          (currentPlayerKey === "player1" && !isFirstServer) ||
          (currentPlayerKey === "player2" && isFirstServer)
        ) {
          _showNotice = true;
          _notice = "Breakpoint";
        }
      }
      updateFB({
        currentScore: temp,
        showNotice: _showNotice,
        notice: _notice,
        isFirstServer: _isFirstServer,
      });
      setShowNotice(_showNotice);
      setNotice(_notice);
      return temp;
    }

    // Normal point progression
    if (currentGame[currentPlayerKey] === 0) {
      currentGame[currentPlayerKey] = 15;
    } else if (currentGame[currentPlayerKey] === 15) {
      currentGame[currentPlayerKey] = 30;
    } else if (currentGame[currentPlayerKey] === 30) {
      currentGame[currentPlayerKey] = 40;
    } else if (currentGame[currentPlayerKey] === 40) {
      // Win game
      currentSet[currentPlayerKey] += 1;
      temp[temp.length - 1] = { player1: 0, player2: 0, type: "regular" };
      let _isFirstServer = (currentSet.player1 + currentSet.player2) % 2 === 0;
      setIsFirstServer(_isFirstServer);
    }

    // Handle notifications
    handleGameNotifications(
      currentGame,
      currentSet,
      currentPlayerKey,
      otherPlayerKey
    );

    // Check for set win
    if (
      currentSet.player1 >= firstToGames &&
      currentSet.player1 - currentSet.player2 >= 2
    ) {
      handleSetWin(temp, 1);
    } else if (
      currentSet.player2 >= firstToGames &&
      currentSet.player2 - currentSet.player1 >= 2
    ) {
      handleSetWin(temp, 2);
    } else if (
      currentSet.player1 === firstToGames &&
      currentSet.player2 === firstToGames
    ) {
      // Start tiebreak
      temp[temp.length - 1] = { player1: 0, player2: 0, type: "tiebreak" };
      _showNotice = true;
      _notice = "Tiebreak";
    }

    updateFB({
      currentScore: temp,
      showNotice: _showNotice,
      notice: _notice,
      isFirstServer: _isFirstServer,
    });
    setShowNotice(_showNotice);
    setNotice(_notice);
    return temp;
  }

  function handleGameNotifications(
    currentGame,
    currentSet,
    currentPlayerKey,
    otherPlayerKey
  ) {
    // First check for match point as it has highest priority
    if (
      isMatchPoint(currentSet, currentGame, currentPlayerKey, otherPlayerKey)
    ) {
      setShowNotice(true);
      setNotice("Match Point");
      return;
    }

    // Show 'Tiebreak' if in a tiebreak and not at match point
    if (currentGame.type === "tiebreak") {
      setShowNotice(true);
      setNotice("Tiebreak");
      return;
    }

    // Then check for golden point
    if (
      currentGame.player1 === 40 &&
      currentGame.player2 === 40 &&
      isGoldenPoint
    ) {
      setShowNotice(true);
      setNotice("Golden Point");
      return;
    }

    // Finally check for break point
    if (
      currentGame[currentPlayerKey] === 40 &&
      currentGame[otherPlayerKey] < 40
    ) {
      if (
        (isFirstServer && currentPlayerKey !== "player1") ||
        (!isFirstServer && currentPlayerKey === "player1")
      ) {
        setShowNotice(true);
        setNotice("Breakpoint");
        return;
      }
    }

    // Clear notifications if no special situation
    setShowNotice(false);
  }

  function isMatchPoint(
    currentSet,
    currentGame,
    currentPlayerKey,
    otherPlayerKey
  ) {
    const sets = [...currentScore].slice(0, -2).reduce(
      (acc, set) => {
        if (set.player1 > set.player2) acc[0]++;
        else if (set.player2 > set.player1) acc[1]++;
        return acc;
      },
      [0, 0]
    );

    const currentPlayerIndex = currentPlayerKey === "player1" ? 0 : 1;
    const otherPlayerIndex = currentPlayerIndex === 0 ? 1 : 0;
    const gamesToWin = Math.ceil(totalNumberOfGames / 2);

    // Only show match point if this point would win the set by 2 games (unless tiebreak)
    // Regular game scenario
    const playerGames = currentSet[currentPlayerKey];
    const opponentGames = currentSet[otherPlayerKey];
    // Check if at game point
    const atGamePoint =
      (currentGame[currentPlayerKey] === 40 ||
        currentGame[currentPlayerKey] === "AD") &&
      currentGame[otherPlayerKey] < 40;
    // Check if winning this game would win the set by 2 games and at least 6 games
    const wouldWinSet =
      playerGames + 1 >= firstToGames && playerGames + 1 - opponentGames >= 2;
    const canWinSet = atGamePoint && wouldWinSet;

    // Tiebreak scenario
    const isTiebreak = currentGame.type === "tiebreak";
    let canWinTiebreak = false;
    if (isTiebreak) {
      const tbScore = currentGame[currentPlayerKey];
      const tbOppScore = currentGame[otherPlayerKey];
      // Only match point if next point would win the tiebreak and match
      canWinTiebreak = tbScore >= firstToGames && tbScore - tbOppScore === 1;
    }

    // Only match point if this point would win the match
    const setsNeeded = gamesToWin;
    const hasSets = sets[currentPlayerIndex] === setsNeeded - 1;
    const matchPoint = hasSets && (canWinSet || (isTiebreak && canWinTiebreak));

    return matchPoint;
  }

  function handleSetWin(temp, winner) {
    const newSets = [...sets];
    newSets[winner - 1]++;
    if (hasPlayerWonMatch(newSets, totalNumberOfGames)) {
      setNotice("Match Over");
      setShowNotice(true);
      setGameIsOver(true);
      gameOverHandled.current = true;
      // Remove the last object in currentScore when game is over
      temp.pop();
      setSets(newSets);
      updateFB({
        sets: newSets,
        currentScore: temp,
        gameIsOver: true,
        showNotice: true,
        notice: "Match Over",
      });
      return;
    }
    // Add new set only if match is not over
    temp.splice(temp.length - 1, 0, { player1: 0, player2: 0 });
    setSets(newSets);
    updateFB({
      sets: newSets,
      currentScore: temp,
      gameIsOver: gameIsOver,
      showNotice: showNotice,
      notice: notice,
    });
  }

  useEffect(() => {
    if (gameIsOver) {
      setShowNotice(true);
      setNotice("Match Over");

      if (!gameOverHandled.current) {
        gameOverHandled.current = true;
        setCurrentScore((prev) => {
          let temp = [...prev];
          if (tennisVariant === "3") temp.pop();
          return temp;
        });
      }
    } else if (tennisVariant === "3") {
      const currentSet = currentScore[currentScore.length - 2];
      const currentGame = currentScore[currentScore.length - 1];
      const p1Games = currentSet?.player1 || 0;
      const p2Games = currentSet?.player2 || 0;

      if (
        currentGame?.player1 === 0 &&
        currentGame?.player2 === 0 &&
        !(p1Games === firstToGames && p2Games === firstToGames)
      ) {
        setShowNotice(false);
      }
    }
  }, [gameIsOver, tennisVariant, currentScore]);

  function handleAdvantageScenarios(
    temp,
    currentGame,
    currentSet,
    winner,
    currentPlayerKey,
    otherPlayerKey
  ) {
    if (currentGame[currentPlayerKey] === "AD") {
      currentSet[currentPlayerKey] += 1;
      temp[temp.length - 1] = { player1: 0, player2: 0, type: "regular" };
    } else {
      currentGame.player1 = 40;
      currentGame.player2 = 40;
    }
    updateFB({ currentScore: temp });
    return true;
  }

  const updateFB = (updateObject) => {
    if (enableFB) {
      update(
        ref(db, "monitors/" + generatedCode), // Reference to the location to update
        updateObject // Data to update
      );
    }
  };

  useEffect(() => {
    if (enableFB && generatedCode) {
      const code = generatedCode;

      try {
        const scoresRef = ref(db, "monitors/" + code);

        // initiateListener
        const unsubscribe = onValue(scoresRef, (snapshot) => {
          if (snapshot.exists()) {
            const data = snapshot.val();

            // Setters for simple key-value pairs
            if (data?.teamA !== undefined) setTeamA(data.teamA);
            if (data?.teamB !== undefined) setTeamB(data.teamB);
            if (data?.firstToPoints !== undefined)
              setFirstToPoints(data.firstToPoints);
            if (data?.gameNumber !== undefined) setGameNumber(data.gameNumber);
            if (data?.totalNumberOfGames !== undefined)
              setTotalNumberOfGames(data.totalNumberOfGames);
            if (data?.firstToGames !== undefined)
              setFirstToGames(data.firstToGames);
            if (data?.tennisVariant !== undefined)
              setTennisVariant(data.tennisVariant);
            if (data?.notice !== undefined) setNotice(data.notice);
            if (data?.gameModeLegs !== undefined)
              setGameModeLegs(data.gameModeLegs);
            if (data?.tiebreakLegs !== undefined)
              setTiebreakLegs(data.tiebreakLegs);
            if (data?.currentScoreboard !== undefined)
              setCurrentScoreboard(data.currentScoreboard);
            if (data?.currentSport !== undefined)
              setCurrentSport(data.currentSport);

            // Setters for arrays with length check
            if (data?.sets?.length === 2) setSets([...data.sets]);
            if (data?.legs?.length === 2) setLegs([...data.legs]);
            if (data?.currentScore !== undefined)
              setCurrentScore([...data.currentScore]);

            // Setters for boolean properties
            if (typeof data?.gameIsOver === "boolean")
              setGameIsOver(data.gameIsOver);
            if (typeof data?.isFirstServer === "boolean")
              setIsFirstServer(data.isFirstServer);
            if (typeof data?.isInitialGameServe === "boolean")
              setIsInitialGameServe(data.isInitialGameServe);
            if (typeof data?.showNotice === "boolean")
              setShowNotice(data.showNotice);
            if (typeof data?.finalLegIsTiebreaker === "boolean")
              setFinalLegIsTiebreaker(data.finalLegIsTiebreaker);
            if (typeof data?.isManualScores === "boolean")
              setIsManualScores(data.isManualScores);
            if (typeof data?.scoreIsTiebreaker === "boolean")
              setScoreIsTiebreaker(data.scoreIsTiebreaker);
            if (data?.crest) setCrest(data?.crest);
            data?.isGoldenPoint ?? setIsGoldenPoint(data?.isGoldenPoint);
          }
        });

        // Cleanup function to stop listening when component is unmounted
        return () => unsubscribe();
      } catch {
        console.log("Error initializing Firebase listener");
      }
    }
  }, [enableFB, generatedCode]);

  value = {
    sets,
    setSets,
    legs,
    setLegs,
    currentScore,
    setCurrentScore,
    undoHistory,
    undo,
    addScore,
    undo,
    isFirstServer,
    setIsFirstServer,
    setIsInitialGameServe,
    notice,
    setNotice,
    showNotice,
    setShowNotice,
    showModalSettings,
    setShowSettingsModal,
    gameModeLegs,
    setGameModeLegs,
    showModalFeedback,
    setShowModalFeedback,
    firstToGames,
    setFirstToGames,
    tiebreakLegs,
    setTiebreakLegs,
    isManualScores,
    setIsManualScores,
    initiateDB,
    enableFB,
    updateFB,
    scoreIsTiebreaker,
    setScoreIsTiebreaker,
    tennisVariant,
    setTennisVariant,
    gameNumber,
    setGameNumber,
    firstToPoints,
    setFirstToPoints,
    totalNumberOfGames,
    setTotalNumberOfGames,
    resetScoreboard,
    setUndoHistory,
    isGoldenPoint,
    setIsGoldenPoint,
  };

  return (
    <TennisContext.Provider value={value}>{children}</TennisContext.Provider>
  );
};

TennisProvider.propTypes = {
  children: PropTypes.node,
};
